/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ChangeUserLanguage
// ====================================================

export interface ChangeUserLanguage_changeUserLanguage {
  __typename: "User";
  id: string;
  language: string | null;
}

export interface ChangeUserLanguage {
  changeUserLanguage: ChangeUserLanguage_changeUserLanguage | null;
}

export interface ChangeUserLanguageVariables {
  input: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SkipTutorialMutation
// ====================================================

export interface SkipTutorialMutation_skipTutorial {
  __typename: "User";
  id: string;
  /**
   * True if user sets skip Tutorial flag
   */
  skipTutorial: boolean;
}

export interface SkipTutorialMutation {
  skipTutorial: SkipTutorialMutation_skipTutorial;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateNotificationSound
// ====================================================

export interface UpdateNotificationSound_updateNotificationSound {
  __typename: "User";
  id: string;
  notificationSound: boolean;
}

export interface UpdateNotificationSound {
  updateNotificationSound: UpdateNotificationSound_updateNotificationSound;
}

export interface UpdateNotificationSoundVariables {
  enabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: MeWithTutorialQuery
// ====================================================

export interface MeWithTutorialQuery_me_company_defaultLanguage {
  __typename: "Language";
  code: string;
}

export interface MeWithTutorialQuery_me_company_trainingCompletionRequirements {
  __typename: "TrainingCompletionRequirements";
  finishAgainstPlayer: boolean;
  winAgainstCPU: boolean;
  allowTutorial: boolean;
  finishedGamesInScene: number;
  percentageOfEliminatedAttacks: number;
}

export interface MeWithTutorialQuery_me_company_gamesConfig {
  __typename: "GameConfig";
  code: string;
  active: boolean;
}

export interface MeWithTutorialQuery_me_company_guide {
  __typename: "CompanyGuide";
  id: number;
  pointingRight: string;
  pointingLeft: string;
  pointingThumbTopRight: string;
  pointingUp: string;
}

export interface MeWithTutorialQuery_me_company_gameFinishedConfig {
  __typename: "CompanyGameFininshedConfig";
  lmsName: string;
  redirectToUrl: string;
}

export interface MeWithTutorialQuery_me_company_layout {
  __typename: "CompanyLayout";
  code: string;
}

export interface MeWithTutorialQuery_me_company {
  __typename: "Company";
  logo: string | null;
  id: string;
  securityManagerName: string | null;
  defaultLanguage: MeWithTutorialQuery_me_company_defaultLanguage;
  trainingCompletionRequirements: MeWithTutorialQuery_me_company_trainingCompletionRequirements;
  gamesConfig: MeWithTutorialQuery_me_company_gamesConfig[];
  guide: MeWithTutorialQuery_me_company_guide;
  gameFinishedConfig: MeWithTutorialQuery_me_company_gameFinishedConfig | null;
  name: string;
  layoutTutorialSceneName: string;
  layout: MeWithTutorialQuery_me_company_layout;
  isActiveTraining: boolean;
}

export interface MeWithTutorialQuery_me_attendees {
  __typename: "UserAttendee";
  /**
   * Attendee's training type
   */
  trainingType: TrainingType;
  /**
   * Attendee's invitation date
   */
  invitedAt: any;
  /**
   * Attendee's completed date
   */
  completedAt: any | null;
  /**
   * Attendee's training name
   */
  trainingName: string;
  /**
   * Attendee's training deadline
   */
  trainingDeadline: any;
}

export interface MeWithTutorialQuery_me_tutorial_game {
  __typename: "Game";
  id: string;
  status: GameStatus;
}

export interface MeWithTutorialQuery_me_tutorial {
  __typename: "Tutorial";
  /**
   * True if user finished any tutorial, regardless of user's game difficulty
   */
  finished: boolean;
  /**
   * True if user closed any tutorial, regardless of user's game difficulty
   */
  closed: boolean;
  /**
   * Opened tutorial game for users's gameDifficulty
   */
  game: MeWithTutorialQuery_me_tutorial_game | null;
}

export interface MeWithTutorialQuery_me {
  __typename: "User";
  id: string;
  name: string | null;
  email: string;
  language: string | null;
  notificationSound: boolean;
  company: MeWithTutorialQuery_me_company | null;
  hasUnconfirmedNotification: boolean;
  canAccessGame: boolean;
  /**
   * True if user sets skip Tutorial flag
   */
  skipTutorial: boolean;
  /**
   * True if user sets skip preview flag
   */
  skipPreview: boolean;
  gameDifficulty: GameDifficulty;
  attendees: MeWithTutorialQuery_me_attendees[] | null;
  tutorial: MeWithTutorialQuery_me_tutorial;
}

export interface MeWithTutorialQuery {
  me: MeWithTutorialQuery_me | null;
}

export interface MeWithTutorialQueryVariables {
  activeTrainingsOnly?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Me
// ====================================================

export interface Me_me_company_defaultLanguage {
  __typename: "Language";
  code: string;
}

export interface Me_me_company_trainingCompletionRequirements {
  __typename: "TrainingCompletionRequirements";
  finishAgainstPlayer: boolean;
  winAgainstCPU: boolean;
  allowTutorial: boolean;
  finishedGamesInScene: number;
  percentageOfEliminatedAttacks: number;
}

export interface Me_me_company_gamesConfig {
  __typename: "GameConfig";
  code: string;
  active: boolean;
}

export interface Me_me_company_guide {
  __typename: "CompanyGuide";
  id: number;
  pointingRight: string;
  pointingLeft: string;
  pointingThumbTopRight: string;
  pointingUp: string;
}

export interface Me_me_company_gameFinishedConfig {
  __typename: "CompanyGameFininshedConfig";
  lmsName: string;
  redirectToUrl: string;
}

export interface Me_me_company {
  __typename: "Company";
  logo: string | null;
  id: string;
  securityManagerName: string | null;
  defaultLanguage: Me_me_company_defaultLanguage;
  trainingCompletionRequirements: Me_me_company_trainingCompletionRequirements;
  gamesConfig: Me_me_company_gamesConfig[];
  guide: Me_me_company_guide;
  gameFinishedConfig: Me_me_company_gameFinishedConfig | null;
}

export interface Me_me {
  __typename: "User";
  id: string;
  name: string | null;
  email: string;
  language: string | null;
  notificationSound: boolean;
  company: Me_me_company | null;
  hasUnconfirmedNotification: boolean;
  canAccessGame: boolean;
  /**
   * True if user sets skip Tutorial flag
   */
  skipTutorial: boolean;
  /**
   * True if user sets skip preview flag
   */
  skipPreview: boolean;
  gameDifficulty: GameDifficulty;
}

export interface Me {
  me: Me_me | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: defenseQuery
// ====================================================

export interface defenseQuery_defense {
  __typename: "Defense";
  text: string | null;
  link: string | null;
  linkText: string | null;
}

export interface defenseQuery {
  defense: defenseQuery_defense[] | null;
}

export interface defenseQueryVariables {
  sceneId: string;
  playerCardId: string;
  hackerCardId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: LanguagesQuery
// ====================================================

export interface LanguagesQuery_languages {
  __typename: "Language";
  code: string;
  name: string;
}

export interface LanguagesQuery {
  languages: LanguagesQuery_languages[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GameStatsQuery
// ====================================================

export interface GameStatsQuery_game_stats_defenses {
  __typename: "DefenseGameStatistics";
  opportunities: number;
  played: number;
}

export interface GameStatsQuery_game_stats_threats {
  __typename: "ThreatGameStatistics";
  selfBurns: number;
  avoidableSelfBurns: number;
}

export interface GameStatsQuery_game_stats {
  __typename: "GameStatistics";
  defenses: GameStatsQuery_game_stats_defenses;
  threats: GameStatsQuery_game_stats_threats;
}

export interface GameStatsQuery_game {
  __typename: "Game";
  id: string;
  stats: GameStatsQuery_game_stats | null;
}

export interface GameStatsQuery {
  game: GameStatsQuery_game | null;
}

export interface GameStatsQueryVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: MeWithCompanyTranslationsQuery
// ====================================================

export interface MeWithCompanyTranslationsQuery_me_company_welcomeTranslations {
  __typename: "CompanyWelcomeTranslation";
  languageCode: string;
  title: string;
  subtitle: string;
  text: string;
}

export interface MeWithCompanyTranslationsQuery_me_company_gdprTranslations {
  __typename: "CompanyGdprTranslation";
  languageCode: string;
  text: string;
}

export interface MeWithCompanyTranslationsQuery_me_company {
  __typename: "Company";
  welcomeTranslations: MeWithCompanyTranslationsQuery_me_company_welcomeTranslations[];
  gdprTranslations: MeWithCompanyTranslationsQuery_me_company_gdprTranslations[];
}

export interface MeWithCompanyTranslationsQuery_me {
  __typename: "User";
  company: MeWithCompanyTranslationsQuery_me_company | null;
}

export interface MeWithCompanyTranslationsQuery {
  me: MeWithCompanyTranslationsQuery_me | null;
}

export interface MeWithCompanyTranslationsQueryVariables {
  languageCode: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: MeWithNotificationQuery
// ====================================================

export interface MeWithNotificationQuery_me_UnconfirmedNotifications_translation {
  __typename: "NotificationTranslation";
  languageCode: string;
  imageLink: string | null;
}

export interface MeWithNotificationQuery_me_UnconfirmedNotifications {
  __typename: "Notification";
  id: string;
  type: NotificationType;
  translation: MeWithNotificationQuery_me_UnconfirmedNotifications_translation | null;
}

export interface MeWithNotificationQuery_me {
  __typename: "User";
  id: string;
  UnconfirmedNotifications: MeWithNotificationQuery_me_UnconfirmedNotifications[];
}

export interface MeWithNotificationQuery {
  me: MeWithNotificationQuery_me | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetNotificationConfirmedMutation
// ====================================================

export interface SetNotificationConfirmedMutation_setNotificationConfirmed {
  __typename: "User";
  id: string;
  hasUnconfirmedNotification: boolean;
}

export interface SetNotificationConfirmedMutation {
  setNotificationConfirmed: SetNotificationConfirmedMutation_setNotificationConfirmed;
}

export interface SetNotificationConfirmedMutationVariables {
  input: SetNotificationConfirmedInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CloseTutorialGame
// ====================================================

export interface CloseTutorialGame {
  closeTutorialGame: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: StartGame
// ====================================================

export interface StartGame {
  startGame: boolean;
}

export interface StartGameVariables {
  input: StartGameInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCertificateLink
// ====================================================

export interface GetCertificateLink {
  certificate: string | null;
}

export interface GetCertificateLinkVariables {
  input: CertificateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ChatQuery
// ====================================================

export interface ChatQuery_chatMessages_originator {
  __typename: "User";
  id: string;
  name: string | null;
}

export interface ChatQuery_chatMessages {
  __typename: "ChatMessage";
  id: string;
  createdAt: any;
  text: string;
  type: ChatMessageType;
  status: ChatMessageStatus;
  originator: ChatQuery_chatMessages_originator;
}

export interface ChatQuery {
  chatMessages: ChatQuery_chatMessages[];
}

export interface ChatQueryVariables {
  gameId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddChatMessageMutation
// ====================================================

export interface AddChatMessageMutation_addChatMessage_originator {
  __typename: "User";
  id: string;
  name: string | null;
}

export interface AddChatMessageMutation_addChatMessage {
  __typename: "ChatMessage";
  id: string;
  createdAt: any;
  text: string;
  type: ChatMessageType;
  status: ChatMessageStatus;
  originator: AddChatMessageMutation_addChatMessage_originator;
}

export interface AddChatMessageMutation {
  addChatMessage: AddChatMessageMutation_addChatMessage;
}

export interface AddChatMessageMutationVariables {
  input: ChatMessageInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetMessageStatusMutation
// ====================================================

export interface SetMessageStatusMutation_setMessageStatus {
  __typename: "ChatMessage";
  id: string;
}

export interface SetMessageStatusMutation {
  setMessageStatus: SetMessageStatusMutation_setMessageStatus[];
}

export interface SetMessageStatusMutationVariables {
  chatMessageIds: string[];
  status: ChatMessageStatus;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL subscription operation: SubscribeChatMessages
// ====================================================

export interface SubscribeChatMessages_chatMessage_originator {
  __typename: "User";
  id: string;
  name: string | null;
}

export interface SubscribeChatMessages_chatMessage {
  __typename: "ChatMessage";
  id: string;
  createdAt: any;
  text: string;
  type: ChatMessageType;
  status: ChatMessageStatus;
  originator: SubscribeChatMessages_chatMessage_originator;
}

export interface SubscribeChatMessages {
  chatMessage: SubscribeChatMessages_chatMessage;
}

export interface SubscribeChatMessagesVariables {
  gameId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL subscription operation: SubscribeChatMessageStatus
// ====================================================

export interface SubscribeChatMessageStatus_chatMessageStatus {
  __typename: "ChatMessage";
  id: string;
  status: ChatMessageStatus;
}

export interface SubscribeChatMessageStatus {
  chatMessageStatus: SubscribeChatMessageStatus_chatMessageStatus[];
}

export interface SubscribeChatMessageStatusVariables {
  gameId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CpuTurn
// ====================================================

export interface CpuTurn {
  cpuTurn: boolean;
}

export interface CpuTurnVariables {
  input: CpuTurnInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GameIdleTimers
// ====================================================

export interface GameIdleTimers_gameIdleTimers {
  __typename: "GameIdleTimers";
  inactive: number;
  activityConfirmation: number;
  offlineMessage: number;
}

export interface GameIdleTimers {
  gameIdleTimers: GameIdleTimers_gameIdleTimers;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetPlayerActivity
// ====================================================

export interface SetPlayerActivity {
  setPlayerActivity: boolean;
}

export interface SetPlayerActivityVariables {
  input: SetPlayerActivityInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL subscription operation: OpponentActivity
// ====================================================

export interface OpponentActivity {
  opponentActivity: PlayerActivity;
}

export interface OpponentActivityVariables {
  gameId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RankedGameDecisionQuery
// ====================================================

export interface RankedGameDecisionQuery_rankedGameDecision_decisionCards_playedCard_card {
  __typename: "Card";
  id: string;
  isHidden: boolean | null;
  text: string | null;
  additionalText: string | null;
  link: string | null;
  linkText: string | null;
  image: string | null;
  points: number[];
}

export interface RankedGameDecisionQuery_rankedGameDecision_decisionCards_playedCard {
  __typename: "PlayedCard";
  zoneId: string;
  card: RankedGameDecisionQuery_rankedGameDecision_decisionCards_playedCard_card;
}

export interface RankedGameDecisionQuery_rankedGameDecision_decisionCards_counterCard_card {
  __typename: "Card";
  id: string;
  isHidden: boolean | null;
  text: string | null;
  additionalText: string | null;
  link: string | null;
  linkText: string | null;
  image: string | null;
  points: number[];
}

export interface RankedGameDecisionQuery_rankedGameDecision_decisionCards_counterCard {
  __typename: "PlayedCard";
  zoneId: string;
  card: RankedGameDecisionQuery_rankedGameDecision_decisionCards_counterCard_card;
}

export interface RankedGameDecisionQuery_rankedGameDecision_decisionCards {
  __typename: "DecisionCards";
  playedCard: RankedGameDecisionQuery_rankedGameDecision_decisionCards_playedCard;
  counterCard: RankedGameDecisionQuery_rankedGameDecision_decisionCards_counterCard;
}

export interface RankedGameDecisionQuery_rankedGameDecision {
  __typename: "RankedGameDecision";
  gameId: string;
  role: PlayerRole;
  rank: DecisionRank;
  decisionCards: RankedGameDecisionQuery_rankedGameDecision_decisionCards;
}

export interface RankedGameDecisionQuery {
  rankedGameDecision: RankedGameDecisionQuery_rankedGameDecision[] | null;
}

export interface RankedGameDecisionQueryVariables {
  input: RankedGameDecisionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetGameDifficultyAndSkipPreviewMutation
// ====================================================

export interface SetGameDifficultyAndSkipPreviewMutation_setGameDifficulty {
  __typename: "User";
  id: string;
  gameDifficulty: GameDifficulty;
}

export interface SetGameDifficultyAndSkipPreviewMutation_skipPreview {
  __typename: "User";
  id: string;
  /**
   * True if user sets skip preview flag
   */
  skipPreview: boolean;
}

export interface SetGameDifficultyAndSkipPreviewMutation {
  setGameDifficulty: SetGameDifficultyAndSkipPreviewMutation_setGameDifficulty;
  skipPreview: SetGameDifficultyAndSkipPreviewMutation_skipPreview;
}

export interface SetGameDifficultyAndSkipPreviewMutationVariables {
  input: SetGameDifficultyInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SkipPreviewMutation
// ====================================================

export interface SkipPreviewMutation_skipPreview {
  __typename: "User";
  id: string;
  /**
   * True if user sets skip preview flag
   */
  skipPreview: boolean;
}

export interface SkipPreviewMutation {
  skipPreview: SkipPreviewMutation_skipPreview;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: OpenCardDetail
// ====================================================

export interface OpenCardDetail {
  openCardDetail: boolean;
}

export interface OpenCardDetailVariables {
  input: OpenCardDetailInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL subscription operation: GameState
// ====================================================

export interface GameState_gameState_StartGameEvent {
  __typename: "StartGameEvent" | "GameClosedEvent" | "ThreePointWarningEvent" | "BurnMissedWarningEvent" | "PowerPlayWarningEvent" | "BurnOldWarningEvent" | "NoCounterWarningEvent" | "EmployeeInactivityEvent" | "FirstHiddenCardEvent" | "SecretTargetInfoEvent" | "FirstTimeHackerEvent" | "FirstHiddenCardHackerEvent" | "WeaknessExposedEvent" | "FirstHackerCardEliminatedEvent";
}

export interface GameState_gameState_FullGameState_game_scene {
  __typename: "Scene";
  id: string;
  name: string | null;
  background: string | null;
  hackerBackground: string;
  employeeBackground: string;
  code: string | null;
}

export interface GameState_gameState_FullGameState_game_field_zones_defenseCards {
  __typename: "Card";
  id: string;
  text: string | null;
  image: string | null;
  isHidden: boolean | null;
  points: number[];
  additionalText: string | null;
  link: string | null;
  linkText: string | null;
}

export interface GameState_gameState_FullGameState_game_field_zones_threatCards {
  __typename: "Card";
  id: string;
  text: string | null;
  image: string | null;
  isHidden: boolean | null;
  points: number[];
  additionalText: string | null;
  link: string | null;
  linkText: string | null;
}

export interface GameState_gameState_FullGameState_game_field_zones {
  __typename: "Zone";
  id: string;
  color: string;
  defenseCards: GameState_gameState_FullGameState_game_field_zones_defenseCards[];
  threatCards: GameState_gameState_FullGameState_game_field_zones_threatCards[];
  hackerPoints: number;
  employeePoints: number;
  isSecretTarget: boolean | null;
}

export interface GameState_gameState_FullGameState_game_field {
  __typename: "Field";
  zones: GameState_gameState_FullGameState_game_field_zones[];
  hasSecretTarget: boolean;
  threatDeckSize: number;
  defenseDeckSize: number;
}

export interface GameState_gameState_FullGameState_game_hacker_hand {
  __typename: "Card";
  id: string;
  text: string | null;
  image: string | null;
  points: number[];
  additionalText: string | null;
  link: string | null;
  linkText: string | null;
}

export interface GameState_gameState_FullGameState_game_hacker_user_company_guide {
  __typename: "CompanyGuide";
  id: number;
  pointingRight: string;
  pointingLeft: string;
  pointingThumbTopRight: string;
  pointingUp: string;
}

export interface GameState_gameState_FullGameState_game_hacker_user_company {
  __typename: "Company";
  id: string;
  guide: GameState_gameState_FullGameState_game_hacker_user_company_guide;
}

export interface GameState_gameState_FullGameState_game_hacker_user {
  __typename: "User";
  id: string;
  company: GameState_gameState_FullGameState_game_hacker_user_company | null;
}

export interface GameState_gameState_FullGameState_game_hacker {
  __typename: "Player";
  name: string | null;
  hand: (GameState_gameState_FullGameState_game_hacker_hand | null)[];
  type: PlayerType;
  user: GameState_gameState_FullGameState_game_hacker_user | null;
}

export interface GameState_gameState_FullGameState_game_employee_hand {
  __typename: "Card";
  id: string;
  text: string | null;
  image: string | null;
  points: number[];
  additionalText: string | null;
  link: string | null;
  linkText: string | null;
}

export interface GameState_gameState_FullGameState_game_employee_user_company {
  __typename: "Company";
  id: string;
}

export interface GameState_gameState_FullGameState_game_employee_user {
  __typename: "User";
  id: string;
  company: GameState_gameState_FullGameState_game_employee_user_company | null;
}

export interface GameState_gameState_FullGameState_game_employee {
  __typename: "Player";
  name: string | null;
  hand: (GameState_gameState_FullGameState_game_employee_hand | null)[];
  type: PlayerType;
  user: GameState_gameState_FullGameState_game_employee_user | null;
}

export interface GameState_gameState_FullGameState_game_myDecisions {
  __typename: "GameDecisionsStats";
  good: number;
  bad: number;
}

export interface GameState_gameState_FullGameState_game {
  __typename: "Game";
  id: string;
  scene: GameState_gameState_FullGameState_game_scene;
  gameDifficulty: GameDifficulty;
  status: GameStatus;
  turn: PlayerRole | null;
  winner: PlayerRole | null;
  percentageOfEliminatedAttacks: string | null;
  myRole: PlayerRole | null;
  round: number;
  isPreview: boolean | null;
  isTutorial: boolean | null;
  previewType: GamePreviewEnum | null;
  field: GameState_gameState_FullGameState_game_field;
  hacker: GameState_gameState_FullGameState_game_hacker;
  employee: GameState_gameState_FullGameState_game_employee;
  myDecisions: GameState_gameState_FullGameState_game_myDecisions;
  actualEvent: string | null;
}

export interface GameState_gameState_FullGameState {
  __typename: "FullGameState";
  game: GameState_gameState_FullGameState_game;
}

export interface GameState_gameState_CardPlayedEvent_playedCard {
  __typename: "Card";
  id: string;
  text: string | null;
  image: string | null;
  isHidden: boolean | null;
  points: number[];
  additionalText: string | null;
  link: string | null;
  linkText: string | null;
}

export interface GameState_gameState_CardPlayedEvent {
  __typename: "CardPlayedEvent";
  playedCard: GameState_gameState_CardPlayedEvent_playedCard;
  zone: string;
}

export interface GameState_gameState_UnsuccessfulDefenseEvent {
  __typename: "UnsuccessfulDefenseEvent";
  defenseCardId: string;
  defenseZoneId: string;
  threatCardId: string;
  threatZoneId: string;
  sceneId: string;
}

export interface GameState_gameState_CardEliminatedEvent {
  __typename: "CardEliminatedEvent";
  eliminatedCardId: string;
  eliminatedCardText: string | null;
  eliminatedCardImage: string | null;
  eliminatingCardId: string;
  zone: string;
}

export interface GameState_gameState_CardDrewEvent_drawnCard {
  __typename: "Card";
  id: string;
  text: string | null;
  image: string | null;
  points: number[];
  additionalText: string | null;
  link: string | null;
  linkText: string | null;
}

export interface GameState_gameState_CardDrewEvent {
  __typename: "CardDrewEvent";
  drawnCard: GameState_gameState_CardDrewEvent_drawnCard | null;
}

export interface GameState_gameState_GameFinishedEvent_hackerDecisions {
  __typename: "GameDecisionsStats";
  good: number;
  bad: number;
}

export interface GameState_gameState_GameFinishedEvent_employeeDecisions {
  __typename: "GameDecisionsStats";
  good: number;
  bad: number;
}

export interface GameState_gameState_GameFinishedEvent {
  __typename: "GameFinishedEvent";
  winner: PlayerRole | null;
  secretTargetId: string | null;
  percentageOfEliminatedAttacks: string;
  hackerDecisions: GameState_gameState_GameFinishedEvent_hackerDecisions;
  employeeDecisions: GameState_gameState_GameFinishedEvent_employeeDecisions;
}

export interface GameState_gameState_NewTurnEvent {
  __typename: "NewTurnEvent";
  nextCardWillBeHidden: boolean;
  round: number;
}

export interface GameState_gameState_WeaknessExposedResultEvent {
  __typename: "WeaknessExposedResultEvent";
  result: string;
}

export interface GameState_gameState_FiveSuccessfulConsecutiveDefencesEvent {
  __typename: "FiveSuccessfulConsecutiveDefencesEvent";
  mediumGameIntroGameId: string | null;
}

export interface GameState_gameState_TenSuccessfulConsecutiveDefencesEvent {
  __typename: "TenSuccessfulConsecutiveDefencesEvent";
  mediumGameIntroGameId: string | null;
}

export interface GameState_gameState_AllAttacksEliminatedEvent {
  __typename: "AllAttacksEliminatedEvent";
  mediumGameIntroGameId: string | null;
}

export type GameState_gameState = GameState_gameState_StartGameEvent | GameState_gameState_FullGameState | GameState_gameState_CardPlayedEvent | GameState_gameState_UnsuccessfulDefenseEvent | GameState_gameState_CardEliminatedEvent | GameState_gameState_CardDrewEvent | GameState_gameState_GameFinishedEvent | GameState_gameState_NewTurnEvent | GameState_gameState_WeaknessExposedResultEvent | GameState_gameState_FiveSuccessfulConsecutiveDefencesEvent | GameState_gameState_TenSuccessfulConsecutiveDefencesEvent | GameState_gameState_AllAttacksEliminatedEvent;

export interface GameState {
  gameState: GameState_gameState;
}

export interface GameStateVariables {
  gameId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: PlayCard
// ====================================================

export interface PlayCard {
  playCard: boolean;
}

export interface PlayCardVariables {
  input: PlayCardInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AcceptGameInvitation
// ====================================================

export interface AcceptGameInvitation_acceptGameInvitation {
  __typename: "GameId";
  id: string;
}

export interface AcceptGameInvitation {
  acceptGameInvitation: AcceptGameInvitation_acceptGameInvitation;
}

export interface AcceptGameInvitationVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RejectGameInvitation
// ====================================================

export interface RejectGameInvitation {
  rejectGameInvitation: boolean | null;
}

export interface RejectGameInvitationVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ActiveGamesByDifficultyAndScene
// ====================================================

export interface ActiveGamesByDifficultyAndScene_activeGamesByDifficultyAndScene_scene {
  __typename: "Scene";
  id: string;
  name: string | null;
}

export interface ActiveGamesByDifficultyAndScene_activeGamesByDifficultyAndScene_hacker_user {
  __typename: "User";
  id: string;
  onlineStatus: OnlineStatus;
  gameDifficulty: GameDifficulty;
}

export interface ActiveGamesByDifficultyAndScene_activeGamesByDifficultyAndScene_hacker {
  __typename: "Player";
  name: string | null;
  user: ActiveGamesByDifficultyAndScene_activeGamesByDifficultyAndScene_hacker_user | null;
}

export interface ActiveGamesByDifficultyAndScene_activeGamesByDifficultyAndScene_employee_user {
  __typename: "User";
  id: string;
  onlineStatus: OnlineStatus;
  gameDifficulty: GameDifficulty;
}

export interface ActiveGamesByDifficultyAndScene_activeGamesByDifficultyAndScene_employee {
  __typename: "Player";
  name: string | null;
  user: ActiveGamesByDifficultyAndScene_activeGamesByDifficultyAndScene_employee_user | null;
}

export interface ActiveGamesByDifficultyAndScene_activeGamesByDifficultyAndScene {
  __typename: "Game";
  id: string;
  status: GameStatus;
  scene: ActiveGamesByDifficultyAndScene_activeGamesByDifficultyAndScene_scene;
  createdAt: string;
  turn: PlayerRole | null;
  myRole: PlayerRole | null;
  gameDifficulty: GameDifficulty;
  hacker: ActiveGamesByDifficultyAndScene_activeGamesByDifficultyAndScene_hacker;
  employee: ActiveGamesByDifficultyAndScene_activeGamesByDifficultyAndScene_employee;
}

export interface ActiveGamesByDifficultyAndScene {
  activeGamesByDifficultyAndScene: ActiveGamesByDifficultyAndScene_activeGamesByDifficultyAndScene[];
}

export interface ActiveGamesByDifficultyAndSceneVariables {
  gameDifficulty: GameDifficulty;
  sceneId: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL subscription operation: GameInvitations
// ====================================================

export interface GameInvitations_gameInvitations_GameInvitations_invitations_inviter {
  __typename: "User";
  id: string;
  email: string;
  name: string | null;
}

export interface GameInvitations_gameInvitations_GameInvitations_invitations {
  __typename: "GameInvitation";
  id: string;
  inviter: GameInvitations_gameInvitations_GameInvitations_invitations_inviter;
}

export interface GameInvitations_gameInvitations_GameInvitations {
  __typename: "GameInvitations";
  invitations: GameInvitations_gameInvitations_GameInvitations_invitations[];
}

export interface GameInvitations_gameInvitations_GameInvitationAdded_added_inviter {
  __typename: "User";
  id: string;
  email: string;
  name: string | null;
}

export interface GameInvitations_gameInvitations_GameInvitationAdded_added {
  __typename: "GameInvitation";
  id: string;
  inviter: GameInvitations_gameInvitations_GameInvitationAdded_added_inviter;
}

export interface GameInvitations_gameInvitations_GameInvitationAdded {
  __typename: "GameInvitationAdded";
  added: GameInvitations_gameInvitations_GameInvitationAdded_added;
}

export interface GameInvitations_gameInvitations_GameInvitationRemoved {
  __typename: "GameInvitationRemoved";
  removed: string;
}

export type GameInvitations_gameInvitations = GameInvitations_gameInvitations_GameInvitations | GameInvitations_gameInvitations_GameInvitationAdded | GameInvitations_gameInvitations_GameInvitationRemoved;

export interface GameInvitations {
  gameInvitations: GameInvitations_gameInvitations;
}

export interface GameInvitationsVariables {
  input: GameInvitationsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL subscription operation: FindNewGame
// ====================================================

export interface FindNewGame_findNewGame_scene {
  __typename: "Scene";
  id: string;
  name: string | null;
}

export interface FindNewGame_findNewGame_hacker_user {
  __typename: "User";
  id: string;
  onlineStatus: OnlineStatus;
  gameDifficulty: GameDifficulty;
}

export interface FindNewGame_findNewGame_hacker {
  __typename: "Player";
  name: string | null;
  user: FindNewGame_findNewGame_hacker_user | null;
}

export interface FindNewGame_findNewGame_employee_user {
  __typename: "User";
  id: string;
  onlineStatus: OnlineStatus;
  gameDifficulty: GameDifficulty;
}

export interface FindNewGame_findNewGame_employee {
  __typename: "Player";
  name: string | null;
  user: FindNewGame_findNewGame_employee_user | null;
}

export interface FindNewGame_findNewGame {
  __typename: "Game";
  id: string;
  status: GameStatus;
  scene: FindNewGame_findNewGame_scene;
  createdAt: string;
  turn: PlayerRole | null;
  myRole: PlayerRole | null;
  gameDifficulty: GameDifficulty;
  hacker: FindNewGame_findNewGame_hacker;
  employee: FindNewGame_findNewGame_employee;
}

export interface FindNewGame {
  findNewGame: FindNewGame_findNewGame;
}

export interface FindNewGameVariables {
  input: FindNewGameInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: OnlineOpponentsQuery
// ====================================================

export interface OnlineOpponentsQuery_onlineOpponents_opponents_user {
  __typename: "User";
  id: string;
  name: string | null;
  email: string;
  gameDifficulty: GameDifficulty;
}

export interface OnlineOpponentsQuery_onlineOpponents_opponents {
  __typename: "OnlineOpponent";
  /**
   * Opponent online status
   */
  status: OnlineStatus;
  /**
   * User object
   */
  user: OnlineOpponentsQuery_onlineOpponents_opponents_user;
}

export interface OnlineOpponentsQuery_onlineOpponents {
  __typename: "OnlineOpponents";
  opponents: OnlineOpponentsQuery_onlineOpponents_opponents[];
  /**
   * Number of all opponents in opponents filed.
   */
  numberOfAllOpponents: number;
}

export interface OnlineOpponentsQuery {
  onlineOpponents: OnlineOpponentsQuery_onlineOpponents;
}

export interface OnlineOpponentsQueryVariables {
  input: OnlineOpponentsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: OnlineUserStatesQuery
// ====================================================

export interface OnlineUserStatesQuery_onlineUserStates {
  __typename: "OnlineUserState";
  id: string;
  /**
   * Opponent user status
   */
  status: OnlineStatus;
}

export interface OnlineUserStatesQuery {
  onlineUserStates: OnlineUserStatesQuery_onlineUserStates[];
}

export interface OnlineUserStatesQueryVariables {
  input: string[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ScenesProgress
// ====================================================

export interface ScenesProgress_playableScenes_progress {
  __typename: "SceneProgress";
  gameCount: number;
  alreadyFinished: boolean;
  tournament: boolean;
}

export interface ScenesProgress_playableScenes {
  __typename: "Scene";
  id: string;
  name: string | null;
  image: string | null;
  progress: ScenesProgress_playableScenes_progress | null;
}

export interface ScenesProgress {
  playableScenes: ScenesProgress_playableScenes[];
}

export interface ScenesProgressVariables {
  input: PlayableScenesInput;
  progressInput: SceneProgressInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CurrentScenes
// ====================================================

export interface CurrentScenes_currentScenes_progress {
  __typename: "SceneProgress";
  gameCount: number;
  alreadyFinished: boolean;
  tournament: boolean;
  training: boolean;
}

export interface CurrentScenes_currentScenes {
  __typename: "Scene";
  id: string;
  name: string | null;
  image: string | null;
  statuses: SceneStatusEnum[] | null;
  progress: CurrentScenes_currentScenes_progress | null;
}

export interface CurrentScenes {
  currentScenes: CurrentScenes_currentScenes[];
}

export interface CurrentScenesVariables {
  gameDifficulty: GameDifficulty;
  progressInput: SceneProgressInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CompanyTraining
// ====================================================

export interface CompanyTraining_companyTraining_scenes {
  __typename: "Scene";
  id: string;
  name: string | null;
}

export interface CompanyTraining_companyTraining {
  __typename: "Training";
  id: string;
  name: string;
  scenes: CompanyTraining_companyTraining_scenes[];
}

export interface CompanyTraining {
  companyTraining: CompanyTraining_companyTraining | null;
}

export interface CompanyTrainingVariables {
  input: CompanyTrainingInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateCpuGame
// ====================================================

export interface CreateCpuGame_createCpuGame {
  __typename: "GameId";
  id: string;
}

export interface CreateCpuGame {
  createCpuGame: CreateCpuGame_createCpuGame;
}

export interface CreateCpuGameVariables {
  input: CreateCpuGameInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetGameDifficulty
// ====================================================

export interface SetGameDifficulty_setGameDifficulty {
  __typename: "User";
  id: string;
  gameDifficulty: GameDifficulty;
}

export interface SetGameDifficulty {
  setGameDifficulty: SetGameDifficulty_setGameDifficulty;
}

export interface SetGameDifficultyVariables {
  input: SetGameDifficultyInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: gamePreviewId
// ====================================================

export interface gamePreviewId {
  gamePreviewId: string | null;
}

export interface gamePreviewIdVariables {
  input: GamePreviewIdInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: TournamentLeaderboardQuery
// ====================================================

export interface TournamentLeaderboardQuery_tournamentsLeaderboard_leaderboards_standings {
  __typename: "TournamentStanding";
  name: string | null;
  email: string;
  standing: number;
}

export interface TournamentLeaderboardQuery_tournamentsLeaderboard_leaderboards {
  __typename: "TournamentLeaderboard";
  tournamentId: number;
  tournamentName: string;
  playerCount: number;
  playerStanding: number | null;
  wins: number;
  winsBySecretTarget: number;
  losses: number;
  lossesBySecretTarget: number;
  standings: TournamentLeaderboardQuery_tournamentsLeaderboard_leaderboards_standings[];
}

export interface TournamentLeaderboardQuery_tournamentsLeaderboard {
  __typename: "TournamentLeaderboards";
  leaderboards: TournamentLeaderboardQuery_tournamentsLeaderboard_leaderboards[];
}

export interface TournamentLeaderboardQuery {
  tournamentsLeaderboard: TournamentLeaderboardQuery_tournamentsLeaderboard;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ProfileStatsQuery
// ====================================================

export interface ProfileStatsQuery_me_gameStatistics {
  __typename: "UserStatistics";
  /**
   * Games won clearly
   */
  wins: number;
  /**
   * Games tied but won on secret target (if played as hacker you won secret target otherwise hacker lost it)
   */
  winsBySecretTarget: number;
  /**
   * Games lost clearly
   */
  losses: number;
  /**
   * Games tied but lost on secret target (if played as hacker you lost secret target otherwise hacer won it)
   */
  lossesBySecretTarget: number;
  /**
   * Position among other players. X of Y this field is X
   */
  standing: number | null;
  /**
   * Number of players for this statistics context. X of Y this field is Y
   */
  playersCount: number;
}

export interface ProfileStatsQuery_me {
  __typename: "User";
  id: string;
  gameStatistics: ProfileStatsQuery_me_gameStatistics | null;
}

export interface ProfileStatsQuery {
  me: ProfileStatsQuery_me | null;
}

export interface ProfileStatsQueryVariables {
  leaderboardType: LeaderboardType;
  trainingId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ActiveGames
// ====================================================

export interface ActiveGames_activeGames_scene {
  __typename: "Scene";
  id: string;
  name: string | null;
}

export interface ActiveGames_activeGames_hacker_user {
  __typename: "User";
  id: string;
  onlineStatus: OnlineStatus;
  gameDifficulty: GameDifficulty;
}

export interface ActiveGames_activeGames_hacker {
  __typename: "Player";
  name: string | null;
  user: ActiveGames_activeGames_hacker_user | null;
}

export interface ActiveGames_activeGames_employee_user {
  __typename: "User";
  id: string;
  onlineStatus: OnlineStatus;
  gameDifficulty: GameDifficulty;
}

export interface ActiveGames_activeGames_employee {
  __typename: "Player";
  name: string | null;
  user: ActiveGames_activeGames_employee_user | null;
}

export interface ActiveGames_activeGames {
  __typename: "Game";
  id: string;
  status: GameStatus;
  scene: ActiveGames_activeGames_scene;
  createdAt: string;
  turn: PlayerRole | null;
  myRole: PlayerRole | null;
  gameDifficulty: GameDifficulty;
  hacker: ActiveGames_activeGames_hacker;
  employee: ActiveGames_activeGames_employee;
}

export interface ActiveGames {
  activeGames: ActiveGames_activeGames[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Invitation
// ====================================================

export interface Invitation_invitation_invitationDetail {
  __typename: "InvitationDetail";
  id: number;
  name: string | null;
  email: string;
}

export interface Invitation_invitation_errors {
  __typename: "InvitationError";
  code: InvitationErrorCode;
}

export interface Invitation_invitation {
  __typename: "InvitationPayload";
  invitationDetail: Invitation_invitation_invitationDetail | null;
  enableMagicLink: boolean;
  errors: Invitation_invitation_errors[];
}

export interface Invitation {
  invitation: Invitation_invitation | null;
}

export interface InvitationVariables {
  token: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: FinishRegistration
// ====================================================

export interface FinishRegistration_finishRegistration_user_company_defaultLanguage {
  __typename: "Language";
  code: string;
}

export interface FinishRegistration_finishRegistration_user_company_trainingCompletionRequirements {
  __typename: "TrainingCompletionRequirements";
  finishAgainstPlayer: boolean;
  winAgainstCPU: boolean;
  allowTutorial: boolean;
  finishedGamesInScene: number;
  percentageOfEliminatedAttacks: number;
}

export interface FinishRegistration_finishRegistration_user_company_gamesConfig {
  __typename: "GameConfig";
  code: string;
  active: boolean;
}

export interface FinishRegistration_finishRegistration_user_company_guide {
  __typename: "CompanyGuide";
  id: number;
  pointingRight: string;
  pointingLeft: string;
  pointingThumbTopRight: string;
  pointingUp: string;
}

export interface FinishRegistration_finishRegistration_user_company_gameFinishedConfig {
  __typename: "CompanyGameFininshedConfig";
  lmsName: string;
  redirectToUrl: string;
}

export interface FinishRegistration_finishRegistration_user_company {
  __typename: "Company";
  logo: string | null;
  id: string;
  securityManagerName: string | null;
  defaultLanguage: FinishRegistration_finishRegistration_user_company_defaultLanguage;
  trainingCompletionRequirements: FinishRegistration_finishRegistration_user_company_trainingCompletionRequirements;
  gamesConfig: FinishRegistration_finishRegistration_user_company_gamesConfig[];
  guide: FinishRegistration_finishRegistration_user_company_guide;
  gameFinishedConfig: FinishRegistration_finishRegistration_user_company_gameFinishedConfig | null;
}

export interface FinishRegistration_finishRegistration_user {
  __typename: "User";
  id: string;
  name: string | null;
  email: string;
  language: string | null;
  notificationSound: boolean;
  company: FinishRegistration_finishRegistration_user_company | null;
  hasUnconfirmedNotification: boolean;
  canAccessGame: boolean;
  /**
   * True if user sets skip Tutorial flag
   */
  skipTutorial: boolean;
  /**
   * True if user sets skip preview flag
   */
  skipPreview: boolean;
  gameDifficulty: GameDifficulty;
}

export interface FinishRegistration_finishRegistration {
  __typename: "FinishRegistrationPayload";
  user: FinishRegistration_finishRegistration_user;
  token: string | null;
}

export interface FinishRegistration {
  finishRegistration: FinishRegistration_finishRegistration;
}

export interface FinishRegistrationVariables {
  input: FinishRegistrationInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ResetPassword
// ====================================================

export interface ResetPassword {
  resetPassword: boolean | null;
}

export interface ResetPasswordVariables {
  input: ResetPasswordInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendPasswordReset
// ====================================================

export interface SendPasswordReset_sendPasswordResetLink_error {
  __typename: "UserHasSSOError";
  message: string;
  locizeErrorKey: string | null;
  tenantUrl: string;
}

export interface SendPasswordReset_sendPasswordResetLink {
  __typename: "SendPasswordResetLinkPayload";
  error: SendPasswordReset_sendPasswordResetLink_error | null;
}

export interface SendPasswordReset {
  sendPasswordResetLink: SendPasswordReset_sendPasswordResetLink;
}

export interface SendPasswordResetVariables {
  email: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateTutorialGame
// ====================================================

export interface CreateTutorialGame_createTutorialGame {
  __typename: "GameId";
  id: string;
}

export interface CreateTutorialGame {
  createTutorialGame: CreateTutorialGame_createTutorialGame;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTutorialQuery
// ====================================================

export interface GetTutorialQuery_me_tutorial_game {
  __typename: "Game";
  id: string;
  status: GameStatus;
}

export interface GetTutorialQuery_me_tutorial {
  __typename: "Tutorial";
  /**
   * True if user finished any tutorial, regardless of user's game difficulty
   */
  finished: boolean;
  /**
   * Opened tutorial game for users's gameDifficulty
   */
  game: GetTutorialQuery_me_tutorial_game | null;
}

export interface GetTutorialQuery_me {
  __typename: "User";
  id: string;
  tutorial: GetTutorialQuery_me_tutorial;
}

export interface GetTutorialQuery {
  me: GetTutorialQuery_me | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetGamePreview
// ====================================================

export interface GetGamePreview_me {
  __typename: "User";
  id: string;
  gameDifficulty: GameDifficulty;
}

export interface GetGamePreview {
  me: GetGamePreview_me | null;
  gamePreviewId: string | null;
}

export interface GetGamePreviewVariables {
  input: GamePreviewIdInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: Game
// ====================================================

export interface Game_scene {
  __typename: "Scene";
  id: string;
  name: string | null;
  background: string | null;
  hackerBackground: string;
  employeeBackground: string;
  code: string | null;
}

export interface Game_field_zones_defenseCards {
  __typename: "Card";
  id: string;
  text: string | null;
  image: string | null;
  isHidden: boolean | null;
  points: number[];
  additionalText: string | null;
  link: string | null;
  linkText: string | null;
}

export interface Game_field_zones_threatCards {
  __typename: "Card";
  id: string;
  text: string | null;
  image: string | null;
  isHidden: boolean | null;
  points: number[];
  additionalText: string | null;
  link: string | null;
  linkText: string | null;
}

export interface Game_field_zones {
  __typename: "Zone";
  id: string;
  color: string;
  defenseCards: Game_field_zones_defenseCards[];
  threatCards: Game_field_zones_threatCards[];
  hackerPoints: number;
  employeePoints: number;
  isSecretTarget: boolean | null;
}

export interface Game_field {
  __typename: "Field";
  zones: Game_field_zones[];
  hasSecretTarget: boolean;
  threatDeckSize: number;
  defenseDeckSize: number;
}

export interface Game_hacker_hand {
  __typename: "Card";
  id: string;
  text: string | null;
  image: string | null;
  points: number[];
  additionalText: string | null;
  link: string | null;
  linkText: string | null;
}

export interface Game_hacker_user_company_guide {
  __typename: "CompanyGuide";
  id: number;
  pointingRight: string;
  pointingLeft: string;
  pointingThumbTopRight: string;
  pointingUp: string;
}

export interface Game_hacker_user_company {
  __typename: "Company";
  id: string;
  guide: Game_hacker_user_company_guide;
}

export interface Game_hacker_user {
  __typename: "User";
  id: string;
  company: Game_hacker_user_company | null;
}

export interface Game_hacker {
  __typename: "Player";
  name: string | null;
  hand: (Game_hacker_hand | null)[];
  type: PlayerType;
  user: Game_hacker_user | null;
}

export interface Game_employee_hand {
  __typename: "Card";
  id: string;
  text: string | null;
  image: string | null;
  points: number[];
  additionalText: string | null;
  link: string | null;
  linkText: string | null;
}

export interface Game_employee_user_company {
  __typename: "Company";
  id: string;
}

export interface Game_employee_user {
  __typename: "User";
  id: string;
  company: Game_employee_user_company | null;
}

export interface Game_employee {
  __typename: "Player";
  name: string | null;
  hand: (Game_employee_hand | null)[];
  type: PlayerType;
  user: Game_employee_user | null;
}

export interface Game_myDecisions {
  __typename: "GameDecisionsStats";
  good: number;
  bad: number;
}

export interface Game {
  __typename: "Game";
  id: string;
  scene: Game_scene;
  gameDifficulty: GameDifficulty;
  status: GameStatus;
  turn: PlayerRole | null;
  winner: PlayerRole | null;
  percentageOfEliminatedAttacks: string | null;
  myRole: PlayerRole | null;
  round: number;
  isPreview: boolean | null;
  isTutorial: boolean | null;
  previewType: GamePreviewEnum | null;
  field: Game_field;
  hacker: Game_hacker;
  employee: Game_employee;
  myDecisions: Game_myDecisions;
  actualEvent: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LobbyGamePlayer
// ====================================================

export interface LobbyGamePlayer_user {
  __typename: "User";
  id: string;
  onlineStatus: OnlineStatus;
  gameDifficulty: GameDifficulty;
}

export interface LobbyGamePlayer {
  __typename: "Player";
  name: string | null;
  user: LobbyGamePlayer_user | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LobbyGame
// ====================================================

export interface LobbyGame_scene {
  __typename: "Scene";
  id: string;
  name: string | null;
}

export interface LobbyGame_hacker_user {
  __typename: "User";
  id: string;
  onlineStatus: OnlineStatus;
  gameDifficulty: GameDifficulty;
}

export interface LobbyGame_hacker {
  __typename: "Player";
  name: string | null;
  user: LobbyGame_hacker_user | null;
}

export interface LobbyGame_employee_user {
  __typename: "User";
  id: string;
  onlineStatus: OnlineStatus;
  gameDifficulty: GameDifficulty;
}

export interface LobbyGame_employee {
  __typename: "Player";
  name: string | null;
  user: LobbyGame_employee_user | null;
}

export interface LobbyGame {
  __typename: "Game";
  id: string;
  status: GameStatus;
  scene: LobbyGame_scene;
  createdAt: string;
  turn: PlayerRole | null;
  myRole: PlayerRole | null;
  gameDifficulty: GameDifficulty;
  hacker: LobbyGame_hacker;
  employee: LobbyGame_employee;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TrainingCompletionRequirements
// ====================================================

export interface TrainingCompletionRequirements_trainingCompletionRequirements {
  __typename: "TrainingCompletionRequirements";
  finishAgainstPlayer: boolean;
  winAgainstCPU: boolean;
  allowTutorial: boolean;
  finishedGamesInScene: number;
  percentageOfEliminatedAttacks: number;
}

export interface TrainingCompletionRequirements {
  __typename: "Company";
  id: string;
  trainingCompletionRequirements: TrainingCompletionRequirements_trainingCompletionRequirements;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BasicUserInfo
// ====================================================

export interface BasicUserInfo_company_defaultLanguage {
  __typename: "Language";
  code: string;
}

export interface BasicUserInfo_company_trainingCompletionRequirements {
  __typename: "TrainingCompletionRequirements";
  finishAgainstPlayer: boolean;
  winAgainstCPU: boolean;
  allowTutorial: boolean;
  finishedGamesInScene: number;
  percentageOfEliminatedAttacks: number;
}

export interface BasicUserInfo_company_gamesConfig {
  __typename: "GameConfig";
  code: string;
  active: boolean;
}

export interface BasicUserInfo_company_guide {
  __typename: "CompanyGuide";
  id: number;
  pointingRight: string;
  pointingLeft: string;
  pointingThumbTopRight: string;
  pointingUp: string;
}

export interface BasicUserInfo_company_gameFinishedConfig {
  __typename: "CompanyGameFininshedConfig";
  lmsName: string;
  redirectToUrl: string;
}

export interface BasicUserInfo_company {
  __typename: "Company";
  logo: string | null;
  id: string;
  securityManagerName: string | null;
  defaultLanguage: BasicUserInfo_company_defaultLanguage;
  trainingCompletionRequirements: BasicUserInfo_company_trainingCompletionRequirements;
  gamesConfig: BasicUserInfo_company_gamesConfig[];
  guide: BasicUserInfo_company_guide;
  gameFinishedConfig: BasicUserInfo_company_gameFinishedConfig | null;
}

export interface BasicUserInfo {
  __typename: "User";
  id: string;
  name: string | null;
  email: string;
  language: string | null;
  notificationSound: boolean;
  company: BasicUserInfo_company | null;
  hasUnconfirmedNotification: boolean;
  canAccessGame: boolean;
  /**
   * True if user sets skip Tutorial flag
   */
  skipTutorial: boolean;
  /**
   * True if user sets skip preview flag
   */
  skipPreview: boolean;
  gameDifficulty: GameDifficulty;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ChatMessageFragment
// ====================================================

export interface ChatMessageFragment_originator {
  __typename: "User";
  id: string;
  name: string | null;
}

export interface ChatMessageFragment {
  __typename: "ChatMessage";
  id: string;
  createdAt: any;
  text: string;
  type: ChatMessageType;
  status: ChatMessageStatus;
  originator: ChatMessageFragment_originator;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PlayedCard
// ====================================================

export interface PlayedCard_card {
  __typename: "Card";
  id: string;
  isHidden: boolean | null;
  text: string | null;
  additionalText: string | null;
  link: string | null;
  linkText: string | null;
  image: string | null;
  points: number[];
}

export interface PlayedCard {
  __typename: "PlayedCard";
  zoneId: string;
  card: PlayedCard_card;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LobbyInvitation
// ====================================================

export interface LobbyInvitation_inviter {
  __typename: "User";
  id: string;
  email: string;
  name: string | null;
}

export interface LobbyInvitation {
  __typename: "GameInvitation";
  id: string;
  inviter: LobbyInvitation_inviter;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OnlineOpponents
// ====================================================

export interface OnlineOpponents_opponents_user {
  __typename: "User";
  id: string;
  name: string | null;
  email: string;
  gameDifficulty: GameDifficulty;
}

export interface OnlineOpponents_opponents {
  __typename: "OnlineOpponent";
  /**
   * Opponent online status
   */
  status: OnlineStatus;
  /**
   * User object
   */
  user: OnlineOpponents_opponents_user;
}

export interface OnlineOpponents {
  __typename: "OnlineOpponents";
  opponents: OnlineOpponents_opponents[];
  /**
   * Number of all opponents in opponents filed.
   */
  numberOfAllOpponents: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OnlineOpponent
// ====================================================

export interface OnlineOpponent_user {
  __typename: "User";
  id: string;
  name: string | null;
  email: string;
  gameDifficulty: GameDifficulty;
}

export interface OnlineOpponent {
  __typename: "OnlineOpponent";
  /**
   * Opponent online status
   */
  status: OnlineStatus;
  /**
   * User object
   */
  user: OnlineOpponent_user;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OnlineUserState
// ====================================================

export interface OnlineUserState {
  __typename: "OnlineUserState";
  id: string;
  /**
   * Opponent user status
   */
  status: OnlineStatus;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserWithStatus
// ====================================================

export interface UserWithStatus {
  __typename: "User";
  id: string;
  onlineStatus: OnlineStatus;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * Possible statuses for chat message
 */
export enum ChatMessageStatus {
  READ = "READ",
  RECEIVED = "RECEIVED",
  SENT = "SENT",
}

/**
 * Possible types for chat message
 */
export enum ChatMessageType {
  EMOTICON = "EMOTICON",
  PREDEFINED_MESSAGE = "PREDEFINED_MESSAGE",
  TEXT = "TEXT",
}

export enum DecisionRank {
  BAD = "BAD",
  GOOD = "GOOD",
}

export enum GameDifficulty {
  EASY = "EASY",
  MEDIUM = "MEDIUM",
}

export enum GamePreviewEnum {
  MEDIUM_GAME_INTRO = "MEDIUM_GAME_INTRO",
}

export enum GamePreviewType {
  MEDIUM_GAME_INTRO = "MEDIUM_GAME_INTRO",
}

export enum GameStatus {
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
  FINISHED = "FINISHED",
}

export enum GameTypeEnum {
  FREE_GAME = "FREE_GAME",
  TOURNAMENT_GAME = "TOURNAMENT_GAME",
  TRAINING_GAME = "TRAINING_GAME",
}

export enum InvitationErrorCode {
  USER_ALREADY_REGISTERED = "USER_ALREADY_REGISTERED",
  USER_HAS_ACTIVE_SO = "USER_HAS_ACTIVE_SO",
  USER_IS_INACTIVE = "USER_IS_INACTIVE",
}

export enum LeaderboardType {
  PVC = "PVC",
  PVP = "PVP",
}

export enum NotificationType {
  AFTER_RELEASE_NOTIFICATION = "AFTER_RELEASE_NOTIFICATION",
  EASY_GAME = "EASY_GAME",
  NEW_SCENE = "NEW_SCENE",
}

export enum OnlineStatus {
  INGAME = "INGAME",
  OFFLINE = "OFFLINE",
  ONLINE = "ONLINE",
}

export enum PlayerActivity {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  OFFLINE = "OFFLINE",
}

export enum PlayerRole {
  EMPLOYEE = "EMPLOYEE",
  HACKER = "HACKER",
}

export enum PlayerType {
  CPU = "CPU",
  HUMAN = "HUMAN",
}

export enum SceneStatusEnum {
  TOURNAMENT = "TOURNAMENT",
  TRAINING = "TRAINING",
  UNFINISHED = "UNFINISHED",
}

/**
 * Possible types for training
 */
export enum TrainingType {
  TOURNAMENT = "TOURNAMENT",
  TRAINING = "TRAINING",
}

export interface CertificateInput {
  trainingId: string;
}

export interface ChatMessageInput {
  text: string;
  gameId: string;
  originatorId: string;
  type: ChatMessageType;
}

export interface CompanyTrainingInput {
  uuid: string;
}

export interface CpuTurnInput {
  gameId: string;
}

export interface CreateCpuGameInput {
  sceneId?: string | null;
  gameType?: GameTypeEnum | null;
}

export interface FindNewGameInput {
  sceneId?: string | null;
  opponentId?: string | null;
  gameType?: GameTypeEnum | null;
}

export interface FinishRegistrationInput {
  token: string;
  name?: string | null;
  password?: string | null;
}

export interface GameInvitationsInput {
  gameType?: GameTypeEnum | null;
}

export interface GamePreviewIdInput {
  gamePreviewType: GamePreviewType;
}

export interface OnlineOpponentsInput {
  resultSize: number;
  searchInput?: string | null;
  sceneId?: string | null;
  gameType?: GameTypeEnum | null;
}

export interface OpenCardDetailInput {
  gameId: string;
  cardId: string;
  zoneId?: string | null;
}

export interface PlayCardInput {
  gameId: string;
  card: string;
  zone: string;
}

export interface PlayableScenesInput {
  trainingType?: TrainingType | null;
}

export interface RankedGameDecisionInput {
  gameId: string;
  decisionRank: DecisionRank;
}

export interface ResetPasswordInput {
  token: string;
  newPassword: string;
}

export interface SceneProgressInput {
  trainingType?: TrainingType | null;
}

export interface SetGameDifficultyInput {
  gameDifficulty: GameDifficulty;
}

export interface SetNotificationConfirmedInput {
  notificationId: string;
}

export interface SetPlayerActivityInput {
  gameId: string;
  activity: PlayerActivity;
}

export interface StartGameInput {
  gameId: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
